module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_hospital02-9182422ac42c80599ca75d7426cb8f0c.png";